export function isCookieEnabledInBrowser() {
  return navigator.cookieEnabled;
}
